import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router'
import {ConnectedRouter} from 'react-router-redux'
import {Provider as StoreProvider} from 'react-redux'
import {createMuiTheme, MuiThemeProvider} from 'material-ui/styles'
import { lightBlue, pink } from 'material-ui/colors'
import { createBrowserHistory } from 'history'

import configureStore from './store.js'
import DatasetGateway from './containers/DatasetGateway'
import './App.css';

const theme = createMuiTheme({
  palette: {
    primary: lightBlue,
    accent: pink
  },
})


let routerHistory = createBrowserHistory()

let {store} = configureStore(routerHistory)

const LandingPage = (props) => (
  "Page not found."
)

class App extends Component {

  render() {    
    return (
      <StoreProvider store={store} >
        <MuiThemeProvider theme={theme}>
          <ConnectedRouter history={routerHistory}>
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route path="/:public_guid" component={DatasetGateway} />
              <Redirect to="/" />
            </Switch>
          </ConnectedRouter>
      </MuiThemeProvider>
    </StoreProvider>
)
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js